import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $: any;

@Component({
  selector: 'app-employee-visiting-card',
  templateUrl: './employee-visiting-card.component.html',
  styleUrls: ['./employee-visiting-card.component.scss'],
})
export class EmployeeVisitingCardComponent implements OnInit {
  visitCardForm: FormGroup;
  submitted: boolean;
  loading: boolean;
  result: any = [];
  emp;
  emp_id;
  departs: any = [];
  segments: any = [];
  vstngData: any = [];
  addressList: any = [];
  costCenteres: any = [];

  constructor(
    private idcardService: DashboardService,
    private notifyService: NotificationService,
    private httpGen: GeneralService
  ) {}

  ngOnInit(): void {
    this.vstngCardField();
    this.getEmpIdCardDetails();
    this.getDepartments();
    this.getSegments();
    this.empVstngCardDetails();
    this.getAddressList();
  }

  closeModal(): void {
    this.submitted = false;
    $('#employee_visiting_card').modal('hide');
    this.visitCardForm.get('no_of_vc').reset();
    this.visitCardForm.get('number').reset();
    this.visitCardForm.get('email_id').reset();
    this.visitCardForm.get('depart').reset();
    this.visitCardForm.get('segment').reset();
    this.visitCardForm.get('address').reset();
    this.visitCardForm.get('std_code').reset();
    this.visitCardForm.get('fax_no').reset();
    this.getEmpIdCardDetails();
    this.empVstngCardDetails();
  }

  get getVstngErr(): any {
    return this.visitCardForm.controls;
  }

  get address(): any {
    return this.visitCardForm.get('address').value;
  }
  get add_type(): any {
    return this.visitCardForm.get('add_type').value;
  }

  vstngCardField(): void {
    this.visitCardForm = new FormGroup({
      emp_id: new FormControl('', Validators.required),
      username: new FormControl(''),
      number: new FormControl('', Validators.required),
      no_of_vc: new FormControl('', Validators.required),
      email_id: new FormControl('', Validators.required),
      add_type: new FormControl('', Validators.required),
      depart: new FormControl(''),
      segment: new FormControl(''),
      address: new FormControl('', Validators.required),
      std_code: new FormControl(''),
      fax_no: new FormControl(''),
    });
  }

  getRoleWiseCostCenters(): void {
    this.httpGen.getEmpCostCenters().subscribe((res) => {
      this.costCenteres = res.data;
    });
  }

  submitVisitCard(): void {
    this.submitted = true;
    if (this.visitCardForm.invalid) {
      return;
    }

    const empVstngCardData = new FormData();
    empVstngCardData.append('emp_id', this.visitCardForm.get('emp_id').value);
    empVstngCardData.append('number', this.visitCardForm.get('number').value);
    empVstngCardData.append(
      'no_of_vc',
      this.visitCardForm.get('no_of_vc').value
    );
    empVstngCardData.append(
      'email_id',
      this.visitCardForm.get('email_id').value
    );
    empVstngCardData.append('depart', this.visitCardForm.get('depart').value);
    empVstngCardData.append('segment', this.visitCardForm.get('segment').value);
    empVstngCardData.append('address', this.visitCardForm.get('address').value);
    empVstngCardData.append(
      'std_code',
      this.visitCardForm.get('std_code').value
    );
    empVstngCardData.append('fax_no', this.visitCardForm.get('fax_no').value);
    empVstngCardData.append('source', 'WEB');

    this.loading = true;
    this.idcardService.addEmpVstngCard(empVstngCardData).subscribe(
      (res) => {
        this.result = res;
        this.submitted = false;
        this.loading = false;
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success !');
          this.closeModal();
        } else {
          this.notifyService.showError(this.result.msg, 'Error !');
          this.closeModal();
        }
      },
      (err) => {
        this.submitted = false;
        this.loading = false;
        this.notifyService.showError(err.error.msg, 'Error !');
      }
    );
  }

  getEmpIdCardDetails(): void {
    this.idcardService.getEmoIdCard().subscribe((res) => {
      this.result = res;
      if (this.result.status == true) {
        this.visitCardForm.patchValue({
          emp_id: this.result.data.id,
          username: this.result.data.username + ' - ' + this.result.data.name,
          number: this.result.data.mobile,
          email_id: this.result.data.email,
          depart: this.result.data.dept_desc,
          segment: this.result.data.seg_desc,
          address: this.result.data.address,
        });
      } else {
      }
    });
  }

  getDepartments(): void {
    this.httpGen.getDepartments().subscribe((res) => {
      this.result = res;
      if (this.result.status == true) {
        this.departs = res.data;
      }
    });
  }

  getSegments(): void {
    this.httpGen.getSegment().subscribe((res) => {
      this.result = res;
      if (this.result.status == true) {
        this.segments = res.data;
      }
    });
  }

  empVstngCardDetails(): void {
    this.idcardService
      .empVstngCardDetails(this.visitCardForm.get('emp_id').value)
      .subscribe((res) => {
        this.result = res;
        if (this.result.status == true) {
          this.vstngData = res.data;
        }
      });
  }

  getAddressList(): void {
    this.idcardService.baseOfficeAddressList().subscribe((res) => {
      this.addressList = res.data;
      this.addressList.push({ value: 'Other', label: 'Other' });
    });
  }

  changeAdd(event): void {
    this.visitCardForm.patchValue({
      address: event.target.value,
    });
  }

  changeAddType(): void {
    this.visitCardForm.get('address').reset();
    if (
      this.visitCardForm.get('add_type').value == 2 &&
      this.costCenteres.length == 0
    ) {
      this.getRoleWiseCostCenters();
    }
  }

  changePcCode(event): void {
    if (event.target.value) {
      this.httpGen.getEntityAddress(4, event.target.value).subscribe((res) => {
        this.visitCardForm.patchValue({
          address: res.data[0].add_line1 + ', ' + res.data[0].cn_name,
        });
      });
    }
  }

  gotoQuery(): void {
    $('#employee_visiting_card').modal('hide');
  }
}
